import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { marketplacesyncApi, type IntegrationDashboard } from '../../api/marketplacesync';

const NAV = [
  { to: '/marketplace-sync/publications', label: 'Publication queue' },
  { to: '/marketplace-sync/feeds', label: 'Feed monitor' },
  { to: '/marketplace-sync/sync', label: 'Synchronization' },
  { to: '/marketplace-sync/retry', label: 'Retry queue' },
  { to: '/marketplace-sync/dead-letter', label: 'Dead letter queue' },
  { to: '/marketplace-sync/connectors', label: 'Connector manager' },
  { to: '/marketplace-sync/webhooks', label: 'Webhook monitor' },
];

export function MarketplaceSyncHubPage() {
  const [dashboard, setDashboard] = useState<IntegrationDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void marketplacesyncApi.dashboard().then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  const stats = dashboard
    ? [
        { label: 'Queued', value: dashboard.queued_publications },
        { label: 'Running', value: dashboard.running_publications },
        { label: 'Failed', value: dashboard.failed_publications },
        { label: 'Active feeds', value: dashboard.active_feeds },
        { label: 'Active syncs', value: dashboard.active_sync_jobs },
        { label: 'Dead letter', value: dashboard.dead_letter_count },
      ]
    : [];

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Marketplace Sync Engine</h1>
      <p className="mt-1 text-sm text-slate-600">Publication, feeds, synchronization, and channel integration.</p>
      <nav className="mt-4 flex flex-wrap gap-3 text-sm">
        {NAV.map((l) => <Link key={l.to} to={l.to} className="text-slate-700 hover:underline">{l.label}</Link>)}
      </nav>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {stats.map((s) => (
          <div key={s.label} className="rounded-xl border bg-white p-4">
            <p className="text-sm text-slate-500">{s.label}</p>
            <p className="mt-1 text-2xl font-semibold">{String(s.value ?? 0)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
